import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Button,
  Dropdown,
  Checkbox
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardAppointmentSummaryListUX = (props: any) => {
    return(
      <div
        id="CardAppointmentSummaryListUX-div-0"
        style={{padding: "15px"}}>
        <div
          id="CardAppointmentSummaryListUX-div-58"
          style={{fontSize: "1.7rem", color: "rgb(79, 79, 79)", fontWeight: "bold", marginBottom: "1.5rem", marginTop: "-0.25rem",display:props.titleName?"":"none"}}>
          {props.titleName}
        </div>
        <div
          className="ui form"
          id="CardAppointmentSummaryListUX-div-1">
          
          <FormGroup
            id="CardAppointmentSummaryListUX-FormGroup-3"
            inline={true}
            style={{display: "flex", alignItems: "flex-end"}}>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-5"
              style={{display: "block"}}
              width="3">
              <label
                id="CardAppointmentSummaryListUX-label-16">
                {props.languageUX === "en" ? "Appointment Type" : "ประเภทนัดหมาย"}
              </label>
              <div
                id="CardAppointmentSummaryListUX-div-23">
                
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardAppointmentSummaryListUX-Dropdown-24"
                  onChange={props.onChange("appointmentType")}
                  options={props.appointmentTypeOptions}
                  selection={true}
                  value={props.appointmentType}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-6"
              style={{display: "block"}}
              width="3">
              <label
                id="CardAppointmentSummaryListUX-label-17">
                {props.languageUX === "en" ? "Appointment status" : "สถานะนัดหมาย"}
              </label>
              <div
                id="CardAppointmentSummaryListUX-div-25">
                
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardAppointmentSummaryListUX-Dropdown-26"
                  onChange={props.onChange("appointmentStatus")}
                  options={props.appointmentStatusOptions}
                  search={true}
                  selection={true}
                  value={props.appointmentStatus}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-7"
              style={{display: "block"}}
              width="2">
              <label
                id="CardAppointmentSummaryListUX-label-18">
                {props.languageUX === "en" ? "Appointment date" : "วันที่นัดหมาย"}
              </label>
              <DateTextBox
                id="CardAppointmentSummaryListUX-DateTextBox-29"
                onChange={props.onDateChange("startDate")}
                value={props.startDate}>
              </DateTextBox>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-8">
              <label
                id="CardAppointmentSummaryListUX-label-19"
                style={{paddingBottom: "10px"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-9"
              style={{display: "block"}}
              width="2">
              <label
                id="CardAppointmentSummaryListUX-label-20">
                
              </label>
              <DateTextBox
                id="CardAppointmentSummaryListUX-DateTextBox-30"
                onChange={props.onDateChange("endDate")}
                value={props.endDate}>
              </DateTextBox>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-10"
              style={{display: "block"}}
              width="3">
              <label
                id="CardAppointmentSummaryListUX-label-21">
                {props.languageUX === "en" ? "Service status" : "สถานะรับบริการ"}
              </label>
              <div
                id="CardAppointmentSummaryListUX-div-27">
                
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardAppointmentSummaryListUX-Dropdown-28"
                  onChange={props.onChange("orderStatus")}
                  options={props.orderStatusOptions}
                  selection={true}
                  value={props.orderStatus}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-11">
              <Button
                color="blue"
                disabled={props.disableShowDetail}
                id="CardAppointmentSummaryListUX-Button-22"
                onClick={props.onClickShowDetail}>
                {props.languageUX === "en" ? "Show details" : "แสดงรายละเอียด"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAppointmentSummaryListUX-FormGroup-4"
            style={{display: "flex", alignItems: "flex-end"}}>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-12"
              style={{display: "block"}}
              width="3">
              <label
                id="CardAppointmentSummaryListUX-label-31">
                {props.languageUX === "en" ? "HN " : "HN "}
              </label>
              <div
                id="CardAppointmentSummaryListUX-div-32">
                {props.searchPatient}
              </div>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-13"
              style={{display: "block"}}
              width="3">
              <div
                id="CardAppointmentSummaryListUX-div-33"
                style={{display: "flex", justifyContent: "space-between"}}>
                
                <label
                  id="CardAppointmentSummaryListUX-label-35"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Doctor" : "แพทย์"}
                </label>
                <Checkbox
                  checked={props.isUnspecifiedDoctor}
                  disabled={!!props.providerDoctor}
                  id="CardAppointmentSummaryListUX-Checkbox-37"
                  label=" ไม่ระบุ"
                  onChange={props.onChange("isUnspecifiedDoctor")}>
                </Checkbox>
              </div>
              <div
                id="CardAppointmentSummaryListUX-div-34">
                
                <Dropdown
                  clearable={true}
                  disabled={props.isUnspecifiedDoctor}
                  fluid={true}
                  id="CardAppointmentSummaryListUX-Dropdown-42"
                  onChange={props.onChange("providerDoctor")}
                  options={props.providerDoctorOptions}
                  search={true}
                  selection={true}
                  value={props.providerDoctor}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-51"
              width={2}>
              <label
                id="CardAppointmentSummaryListUX-label-53"
                style={{margin: 0}}>
                {props.languageUX === "en" ? "Specialty " : "ความเชี่ยวชาญ"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardAppointmentSummaryListUX-Dropdown-55"
                onChange={props.onChange("specialty")}
                options={props.specialtyOptions}
                selection={true}
                value={props.specialty || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-52"
              width={2}>
              <label
                id="CardAppointmentSummaryListUX-label-54"
                style={{margin: 0}}>
                {props.languageUX === "en" ? "Appointment for" : "นัดหมายเพื่อ"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardAppointmentSummaryListUX-Dropdown-56"
                onChange={props.onChange("patientAppTypeWL")}
                options={props.patientAppTypeWLOptions}
                selection={true}
                style={{width: "calc(100% - -1.5rem)"}}
                value={props.patientAppTypeWL || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-14"
              style={{marginRight: "-0.5rem", marginLeft: "1.5rem"}}>
              <label
                id="CardAppointmentSummaryListUX-label-50">
                {"\u00a0"}
              </label>
              <Button
                color="blue"
                id="CardAppointmentSummaryListUX-Button-38"
                loading={props.loadingFilterAppList}
                onClick={props.onSearch}>
                {props.languageUX === "en" ? "Search" : "ค้นหา"}
              </Button>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-44"
              style={{marginRight: "-0.5rem"}}>
              <label
                id="CardAppointmentSummaryListUX-label-47">
                {"\u00a0"}
              </label>
              <div
                id="CardAppointmentSummaryListUX-div-57">
                {props.buttonPrintReport}
              </div>
            </FormField>
            <FormField
              id="CardAppointmentSummaryListUX-FormField-45">
              <label
                id="CardAppointmentSummaryListUX-label-46">
                {"\u00a0"}
              </label>
              <div
                id="CardAppointmentSummaryListUX-div-48">
                {props.buttonDownloadFile}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardAppointmentSummaryListUX-div-2">
          
          <Table
            data={props.appointmentData}
            defaultPageSize="10"
            getTrProps={props.onGetPatientRow}
            headers={props.languageUX === "en" ? ",HN,Patient name,Telephone,Doctor,Speciality,Appointment for,Appointment Datetime, Appointment status,Services date,Services status" : ",HN,ชื่อ - สกุล,เบอร์โทร,แพทย์,ความเชี่ยวชาญ,นัดหมายเพื่อ,วันที่นัดหมาย,สถานะนัดหมาย,วันที่รับบริการ,สถานะรับบริการ"}
            id="CardAppointmentSummaryListUX-Table-15"
            keys="_icon,hn,patient_name,tel,doctor_name,specialty_text,appointment_for_text,appointment_date,appointment_status,service_date,service_status"
            minRows="10"
            pageSize={10}
            showPagination={false}
            style={{height: "50vh"}}
            widths="60,^80,^80,^80,^100,^80,^80,^80,^80,^80,^80">
          </Table>
        </div>
        <div
          id="CardAppointmentSummaryListUX-div-40"
          style={{display: "flex", justifyContent: "flex-end", padding: "5px"}}>
          {props.pagination}
        </div>
      </div>
    )
}


export default CardAppointmentSummaryListUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-1"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-2"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"flex-end\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormGroup-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"flex-end\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-6"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-9"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-10"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-12"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-13"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-14"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"-0.5rem\", marginLeft: \"1.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 15,
      "name": "Table",
      "parent": 2,
      "props": {
        "data": {
          "type": "code",
          "value": "props.appointmentData"
        },
        "defaultPageSize": {
          "type": "value",
          "value": "10"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetPatientRow"
        },
        "headers": {
          "type": "value",
          "value": ",HN,ชื่อ - สกุล,เบอร์โทร,แพทย์,ความเชี่ยวชาญ,นัดหมายเพื่อ,วันที่นัดหมาย,สถานะนัดหมาย,วันที่รับบริการ,สถานะรับบริการ",
          "valueEN": ",HN,Patient name,Telephone,Doctor,Speciality,Appointment for,Appointment Datetime, Appointment status,Services date,Services status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Table-15"
        },
        "keys": {
          "type": "value",
          "value": "_icon,hn,patient_name,tel,doctor_name,specialty_text,appointment_for_text,appointment_date,appointment_status,service_date,service_status"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"50vh\"}"
        },
        "widths": {
          "type": "value",
          "value": "60,^80,^80,^80,^100,^80,^80,^80,^80,^80,^80"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทนัดหมาย",
          "valueEN": "Appointment Type"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะนัดหมาย",
          "valueEN": "Appointment status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดหมาย",
          "valueEN": "Appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"10px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะรับบริการ",
          "valueEN": "Service status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Button",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "แสดงรายละเอียด",
          "valueEN": "Show details"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disableShowDetail"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Button-22"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickShowDetail"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Dropdown",
      "parent": 23,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Dropdown-24"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"appointmentType\")"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentType"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Dropdown",
      "parent": 25,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Dropdown-26"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"appointmentStatus\")"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentStatusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentStatus"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-27"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Dropdown",
      "parent": 27,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Dropdown-28"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"orderStatus\")"
        },
        "options": {
          "type": "code",
          "value": "props.orderStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.orderStatus"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 29,
      "name": "DateTextBox",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-DateTextBox-29"
        },
        "onChange": {
          "type": "code",
          "value": "props.onDateChange(\"startDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 30,
      "name": "DateTextBox",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-DateTextBox-30"
        },
        "onChange": {
          "type": "code",
          "value": "props.onDateChange(\"endDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "HN ",
          "valueEN": "HN "
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchPatient"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "Doctor"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-35"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Checkbox",
      "parent": 33,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isUnspecifiedDoctor"
        },
        "disabled": {
          "type": "code",
          "value": "!!props.providerDoctor",
          "valueEN": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Checkbox-37"
        },
        "label": {
          "type": "value",
          "value": " ไม่ระบุ"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"isUnspecifiedDoctor\")"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Button",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Button-38"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingFilterAppList"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", padding: \"5px\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Dropdown",
      "parent": 34,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isUnspecifiedDoctor"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Dropdown-42"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"providerDoctor\")"
        },
        "options": {
          "type": "code",
          "value": "props.providerDoctorOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.providerDoctor"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-44"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"-0.5rem\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-45"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-46"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 44,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonDownloadFile"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-50"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-51"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-FormField-52"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "ความเชี่ยวชาญ",
          "valueEN": "Specialty "
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "นัดหมายเพื่อ",
          "valueEN": "Appointment for"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-label-54"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Dropdown",
      "parent": 51,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Dropdown-55"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"specialty\")"
        },
        "options": {
          "type": "code",
          "value": "props.specialtyOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.specialty || \"\""
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Dropdown",
      "parent": 52,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-Dropdown-56"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"patientAppTypeWL\")"
        },
        "options": {
          "type": "code",
          "value": "props.patientAppTypeWLOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(100% - -1.5rem)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patientAppTypeWL || \"\""
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintReport"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-57"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.titleName"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.7rem\", color: \"rgb(79, 79, 79)\", fontWeight: \"bold\", marginBottom: \"1.5rem\", marginTop: \"-0.25rem\",display:props.titleName?\"\":\"none\"}"
        }
      },
      "seq": 1,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardAppointmentSummaryListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
